import { useMutation } from "react-query";
import templateFormService from "../../services/templateFormService";

const useAddFormComment = () => useMutation(templateFormService.addFormComment)

export default useAddFormComment;